const {
  DATASET_CONSENT_VERSION,
  DATASET_PRIVACY_VERSION,
  DATASET_TERMS_VERSION,
} = require('../../shared/datasetConfig.json');

export const DATASET_CONSENT_STORAGE_KEY = 'fesmelacta.datasetConsent.v1';

function currentConsent() {
  return {
    accepted: true,
    termsVersion: DATASET_TERMS_VERSION,
    privacyVersion: DATASET_PRIVACY_VERSION,
    consentVersion: DATASET_CONSENT_VERSION,
  };
}

export function getDatasetConsent() {
  try {
    const stored = JSON.parse(localStorage.getItem(DATASET_CONSENT_STORAGE_KEY) || 'null');
    const current = currentConsent();
    const valid = stored?.accepted === true
      && stored.termsVersion === current.termsVersion
      && stored.privacyVersion === current.privacyVersion
      && stored.consentVersion === current.consentVersion;
    if (valid) return true;
  } catch (error) {
    // Invalid local data is treated as no consent.
  }
  localStorage.removeItem(DATASET_CONSENT_STORAGE_KEY);
  return false;
}

export function setDatasetConsent(accepted) {
  if (!accepted) return localStorage.removeItem(DATASET_CONSENT_STORAGE_KEY);
  localStorage.setItem(DATASET_CONSENT_STORAGE_KEY, JSON.stringify(currentConsent()));
}
